module.exports = __webpack_public_path__ + "static/img/装饰5.c6a870d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰5.svg
// module id = ZINq
// module chunks = 2